import { createFileRoute } from "@tanstack/react-router";

import { GovernancePage } from "@/features/insights/governance";

export const Route = createFileRoute("/_authenticated/intel/governance")({
  component: GovernancePage,
});
